<form class="filter" #formElement [formGroup]="form">
  <mat-form-field class="medium-width margin-right-small">
    <input
      matInput
      autocomplete="off"
      formControlName="date"
      [matDatepicker]="pickerFrom"
      placeholder="Fecha"
      required
    />
    <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
    <mat-datepicker #pickerFrom></mat-datepicker>
    <mat-error *ngIf="f.date.errors && f.date.errors.required">
      Ingrese la fecha
    </mat-error>
  </mat-form-field>

  <mat-form-field class="full-width">
    <input
      type="text"
      #practiceRegion
      matInput
      placeholder="Práctica"
      formControlName="practiceRegion"
      [matAutocomplete]="autPracticeRegion"
    />
    <mat-autocomplete
      #autPracticeRegion="matAutocomplete"
      [displayWith]="filterCompletePracticesRegion.displayFn"
    >
      <mat-option
        *ngFor="let practiceRegion of filteredPracticesRegionOptions | async"
        [value]="practiceRegion"
      >
        {{ practiceRegion.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <div class="full-width">
    <patient-autocomplete formControlName="patient"></patient-autocomplete>
  </div>
  <mat-checkbox class="margin-right-small" formControlName="atended">Ver atendidos</mat-checkbox>
  <mat-checkbox class="margin-right-small" formControlName="interned">Ver internados</mat-checkbox>

</form>
